// extracted by mini-css-extract-plugin
export default {"testimonial":"testimonial--1otdX","inner":"inner--1otdX","body":"body--1otdX","bottom":"bottom--1otdX","name":"name--1otdX"};